module.exports = __webpack_public_path__ + "static/media/se_1.9cc04349.mp3";